<template>
  <svg
    width="110px"
    height="142px"
    viewBox="0 0 110 142"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <!-- Generator: Sketch 53.1 (72631) - https://sketchapp.com -->
    <title>Open Jar</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Final-Design"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Firefly-03"
        transform="translate(-132.000000, -284.000000)"
      >
        <g
          id="Group-2"
          transform="translate(187.500000, 356.500000) rotate(-23.000000) translate(-187.500000, -356.500000) translate(152.000000, 292.000000)"
        >
          <path
            id="Path"
            :fill="color"
            d="M0.903929459,117.527507 L0.903929459,30.1010441 C0.903929459,21.332763 10.526704,19.6985418 10.7137138,13.2403095 C10.7855256,10.6943036 9.98661983,8.48038541 7.23533214,6.38735883 L64.5740229,6.38735883 C61.8212391,8.48038541 61.0208373,10.6943036 61.0956412,13.2403095 C61.2811549,19.6985418 70.9039295,21.332763 70.9039295,30.1010441 L70.9039295,117.526051 C70.9039295,123.991566 66.3259304,128.387358 60.9460334,128.387358 L10.8603295,128.387358 C5.48043248,128.388815 0.903929459,123.993022 0.903929459,117.527507 L0.903929459,117.527507 Z"
          ></path>
          <path
            id="Path"
            :fill="color"
            d="M2.55371358,0.913768947 L2.55371358,7.54284792 C2.55371358,7.92067108 2.86213878,8.22979911 3.24093285,8.22979911 L67.8649971,8.22979911 C68.2437912,8.22979911 68.5537136,7.92067108 68.5537136,7.54284792 L68.5537136,0.913768947 C68.5537136,0.537439165 68.2437912,0.229804502 67.8649971,0.229804502 L3.23943564,0.229804502 C2.86064157,0.22831113 2.55371358,0.537439165 2.55371358,0.913768947 L2.55371358,0.913768947 Z"
          ></path>
          <path
            d="M9.14100933,32.8680666 L9.14100933,33.803159 C9.14100933,35.9996064 10.9331821,37.7809427 13.1402382,37.7809427 L13.1417805,37.7809427 C15.3488366,37.7809427 17.139467,35.9996064 17.139467,33.803159 L17.139467,32.8680666 C17.139467,30.6730758 15.3488366,28.8902829 13.1417805,28.8902829 L13.1402382,28.8902829 C10.9331821,28.8902829 9.14100933,30.6730758 9.14100933,32.8680666 L9.14100933,32.8680666 Z M9.13946701,45.148072 L9.13946701,111.911043 C9.13946701,114.106034 10.9316397,115.890283 13.1386959,115.890283 L13.1402382,115.890283 C15.3472943,115.890283 17.1379247,114.10749 17.1379247,111.911043 L17.1379247,45.148072 C17.1379247,42.9545376 15.3472943,41.1702883 13.1402382,41.1702883 L13.1386959,41.1702883 C10.9316397,41.1702883 9.13946701,42.9545376 9.13946701,45.148072 L9.13946701,45.148072 Z"
            id="Reflection"
            fill="#FFFFFF"
            opacity="0.5"
          ></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    props: ["color"]
  };
</script>
